import { Component, inject, Input, OnInit } from '@angular/core';
import { AuthService } from '@app/core/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-welcome-card',
    templateUrl: './welcome-card.component.html',
    styleUrls: ['./welcome-card.component.scss'],
    standalone: false
})
export class WelcomeCardComponent implements OnInit {
    @Input() username?: string;
    @Input() temperature: number = 22;
    @Input() city: string = '...';
    @Input() avatarUrl?: string;

    greeting: string = '';
    formattedName: string = '';
    currentHour: number = new Date().getHours();
    todayFormatted: string = '';

    readonly shineOnceClass = 'shine-once';

    private readonly auth = inject(AuthService);

    async ngOnInit() {
        const usuario = await this.auth.returnUserInfo();

        this.avatarUrl = usuario?.imagen_perfil ? environment.imagesUrl + 'avatar/' + usuario?.imagen_perfil : '';
        
        // Nombre preferido: Nombre Apellido -> sino usuario
        if (usuario) {
            const preferred = [usuario.nombre /**, usuario.apellido */]
                .filter((p): p is string => !!p && p.trim().length > 0)
                .join(' ')
                .trim();
            this.username = (preferred || usuario.usuario || '').trim();
        }

        const hour = new Date().getHours();
        this.greeting = hour < 12 ? '¡Buen día' : hour < 19 ? '¡Buenas tardes' : '¡Buenas noches';

        const hoy = new Date();
        const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        this.todayFormatted = `${dias[hoy.getDay()]}, ${hoy.getDate()} de ${meses[hoy.getMonth()]}`;
    }

    /** Nombre final mostrado (sin estado, evita problemas de ciclo de vida) */
    get displayFormattedName(): string {
        const name = (this.username ?? '').trim();
        if (!name) return 'Usuario';
        return name.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
    }

    get initials(): string {
        const parts = this.displayFormattedName.split(' ').filter(Boolean);
        return (parts[0]?.[0] ?? 'U') + (parts[1]?.[0] ?? '');
    }
}
